export default "__VITE_ASSET__DFDjTAIf__"